import { useEffect, useRef, useState } from 'react';

export const useFps = (id: string, fpsTracker: null | Record<string, { fps: number; avg: number; count: number }> = null): [number, number, number] => {
	// fps tracking
	const [fps, setFps] = useState(0);
	const frameCount = useRef(0);
	const fpsCount = useRef(0);
	const avgFps = useRef(0);
	const lastTime = useRef(performance.now());

	useEffect(() => {
		let animationFrameId = null;

		const loop = (time) => {
			frameCount.current++;

			const delta = time - lastTime.current;
			if (delta >= 1000) {
				const fpsTemp = (frameCount.current * 1000) / delta;
				fpsCount.current++;
				setFps(Math.round(fpsTemp));
				if (avgFps.current === 0) avgFps.current = fpsTemp;
				else avgFps.current = Math.round(((avgFps.current * (fpsCount.current - 1)) + fpsTemp) / fpsCount.current);

				frameCount.current = 0;
				lastTime.current = time;
			}

			animationFrameId = requestAnimationFrame(loop);
		};

		animationFrameId = requestAnimationFrame(loop);

		return () => cancelAnimationFrame(animationFrameId);
	}, []);

	if (fpsTracker) fpsTracker[id] = { fps, avg: avgFps.current, count: fpsCount.current };
	return [fps, avgFps.current, fpsCount.current];
};
